<template>
  <div
    v-if="visible"
    class="map-attribution"
    aria-label="Map data attribution"
  >&copy; OpenStreetMap contributors</div>
</template>

<script>
import { mapGetters } from 'vuex'

/**
 * Bottom-left overlay showing the required OpenStreetMap attribution.
 * Visible only while the map is displaying an OSM-sourced boundary (county
 * polygon or circle). Hidden for non-county searches that use only Google
 * data, so the attribution doesn't appear unnecessarily.
 *
 * The element is positioned absolutely within the map container and sized
 * to match Google's own attribution line for visual parity.
 */
export default {
  name: 'MapAttribution',

  computed: {
    ...mapGetters('map', ['searchAreaSource']),

    visible() {
      return this.searchAreaSource === 'osm'
    },
  },
}
</script>

<style scoped>
.map-attribution {
  position: absolute;
  left: 8px;
  bottom: 4px;
  z-index: 1;
  padding: 1px 4px;
  background: rgba(255, 255, 255, 0.75);
  border-radius: 2px;
  color: #333;
  font-family: Roboto, Arial, sans-serif;
  font-size: 11px;
  line-height: 1.4;
  pointer-events: none;
  user-select: none;
}
</style>
